import React, { useState, useEffect, useRef } from "react";
import Status from "../Components/Status";
import env, { normalPriceCount } from "../../env";
import ErrorAction from "../../components/PopUps/ErrorAction";

function SlidersTableRow(props) {
  const [openOption, setOpenOption] = useState(false);
  const [checkState, setCheckState] = useState(false);
  const [alert, setAlert] = useState(false);

  const activeAcc = props.index === props.detail;
  const slider = props.slider;

  const menuRef = useRef(null);

  // بستن منو با کلیک خارج از آن
  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenOption(false);
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, []);

  // حذف اسلایدر
  const deleteSlider = () => {
    const postOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        sliderId: slider._id,
      }),
    };

    fetch(env.siteApi + "/setting/sliders/deleteSlider", postOptions)
      .then((res) => res.json())
      .then((result) => {
        if (result.error) {
          console.log(result.error);
        } else {
          setAlert(false);
          setTimeout(() => {
            window.location.href = "/sliders";
          }, 2000);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <React.Fragment>
      <tr className={activeAcc ? "activeAccordion" : "accordion"}>
        <td className="checkBoxStyle">
          <input
            type="checkbox"
            checked={checkState}
            onChange={(e) => setCheckState(e.target.checked)}
          />
        </td>

        <td>
          <div className="cu-avatar">
            <img
              src={slider ? env.siteApiUrl + slider.thumbUrl : ""}
              alt={slider ? slider.title : "default"}
            />

            <div
              className="cu-name"
              onClick={() =>
                (window.location.href = "/sliders/detail/" + slider._id)
              }
            >
              <p className="name">{slider.title}</p>
              <p className="email">{slider.sku}</p>
            </div>

            {slider.moreInformation ? (
              <i className="fa fa-comment-o" title={slider.moreInformation}></i>
            ) : null}
          </div>
        </td>

        <td>
          <div className="order-num">
            <p>{slider.sliderCode}</p>
          </div>
        </td>

        {/* <td>
          <Status
            status={slider.status}
            class={"order-status"}
            lang={props.lang}
          />
        </td> */}

        <td className="p-r">
          <div className="more-btn">
            <i
              className={`tableIcon fas ${
                activeAcc ? "fa-chevron-up" : "fa-chevron-down"
              }`}
              onClick={() => props.showDetail(activeAcc ? "-1" : props.index)}
            ></i>

            <i
              className="tableIcon fas fa-edit"
              onClick={() =>
                (window.location.href = "/sliders/detail/" + slider._id)
              }
            ></i>

            <i
              className="tableIcon fas fa-ellipsis-v"
              onClick={() => setOpenOption((prev) => !prev)}
            ></i>
          </div>

          <div
            className={
              openOption ? "sub-more-menu sub-active" : "sub-more-menu"
            }
            ref={menuRef}
          >
            <div
              className="sub-option sub-delete"
              onClick={() => {
                setAlert(true);
                setOpenOption(false);
              }}
            >
              <i
                className="tableIcon fas fa-remove"
                style={{ color: "#ff0000" }}
              ></i>
              <p>Delete</p>
            </div>

            <div
              className="sub-option sub-edit"
              onClick={() =>
                (window.location.href = "/sliders/detail/" + slider._id)
              }
            >
              <i className="tableIcon fas fa-edit"></i>
              <p>Edit</p>
            </div>
          </div>
        </td>
      </tr>

      {alert && (
        <ErrorAction
          status={"DELETE"}
          title={"حذف اسلایدر"}
          text={"اسلایدر انتخاب شده حذف خواهد شد. آیا مطمئن هستید؟"}
          linkText={""}
          style={{ direction: "rtl" }}
          buttonText="حذف"
          close={() => setAlert(false)}
          action={deleteSlider}
        />
      )}
    </React.Fragment>
  );
}

export default SlidersTableRow;
